import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as c } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const o = c((r, e) => /* @__PURE__ */ s.jsx(
  i,
  {
    ref: e,
    ...r,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_3568",
              width: 12,
              height: 14,
              x: 2,
              y: 1,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M8.48 3.22c0-.03.02-.06.02-.09V2.5H9c.41 0 .75-.34.75-.75S9.41 1 9 1H6.5c-.41 0-.75.34-.75.75s.34.75.75.75H7v.64c0 .03.01.06.02.08C4.19 3.59 2 6 2 8.92c0 3.17 2.58 5.75 5.75 5.75s5.75-2.58 5.75-5.75c0-2.92-2.19-5.33-5.02-5.7m-.73 9.95A4.26 4.26 0 0 1 3.5 8.92a4.26 4.26 0 0 1 4.25-4.25A4.26 4.26 0 0 1 12 8.92a4.26 4.26 0 0 1-4.25 4.25"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M10.09 8.17H8.5V6.58c0-.41-.34-.75-.75-.75S7 6.17 7 6.58v2.34c0 .41.34.75.75.75h2.34c.41 0 .75-.34.75-.75s-.34-.75-.75-.75"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3568)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyTimerIcon";
export {
  o as AgencyTimerIcon,
  o as default
};
//# sourceMappingURL=index.js.map
